<template>
	<!-- 产品服务 -->
	<div class="product">
		
		<!-- 产品解决方案 -->
		<div class="programme share_Up_down" ref="programme"  >
			<div  class="title share_center_Up_down animate__animated animate__fadeInUp">
				产品解决方案
				<span>“全能三角形”一站式解决方案</span>
			</div>
			<div ref="programmeWrap"  class="wrap share_list">
				<div  class="left animate__animated animate__fadeInUp"></div>
				<div  class="right animate__animated animate__fadeInUp">
					<ul>
						<li>
							<p></p>
							<span>需求调研，生成报告，方式设计，CMS（内容管理）方案式匹配，素材自动化生成</span>
						</li>
						<li>
							<p></p>
							<span> CDP、MA，智能工具，私域裂变，精准获客，用户管理，数据决策，线索跟进，会员复购激活</span>
						</li>
						<li>
							<p></p>
							<span> 组织培训，活动预热，活动前中后节点执行，数据复盘 </span>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<!-- 品牌定位 -->
		<div class="process share_Up_down" ref="brandPos"  >
			<div  v-show="brandShow"  class="title share_Up_down-center animate__animated animate__fadeInUp">
				品牌定位
				<span>BRAND POSITIONING </span>
			</div>
			<div v-show="brandShow"  class="process_pic"  >
				<img    class="animate__animated animate__fadeInUp" src="../../../public/images/brand_02.png" >
			</div>
			<!-- 移动端样式 -->
			<div  v-show="brandShow" class="process_pic2"  >
				<img class="animate__animated animate__fadeInUp" src="../../../public/images/brand_02.png" >
			</div>
			<!-- 移动端样式 end-->
		</div>
	   <!-- 品牌矩阵 -->
		<div class="card share_center"  ref="BrandMatrix" >
			<div class="card_box share_center_Up_down">
				<!-- pc -->
				<div class=" cooperationPc ">
					<div v-show="matrixShow" class="brand share_Up_down-center animate__animated animate__fadeInUp">
						<div >旗下三大品牌矩阵</div>
						<span class="text">Matrix of its three major brands</span>
					</div>
					<div class="list" v-show="matrixShow">
						<div class="son" v-for="(item,index) in caseList" :key='index' >
							<div class="pic">
								<img :src="item.pic" >
							</div>
							<div class="content">
								<div class="title">
									{{item.title}}
								</div>
								<div class="text">
									{{item.text}}
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- 移动端下展示 -->
				<div class="cooperation  ">
					<div v-show="matrixShow" class="brand share_Up_down-center animate__animated animate__fadeInUp">
						<div >旗下三大品牌矩阵</div>
						<span class="text">Matrix of its three major brands</span>
					</div>
					<div class="list" v-show="matrixShow">
						<div class="son" v-for="(item,index) in caseList" :key='index' >
							<div class="pic">
								<img :src="item.pic" >
							</div>
							<div class="content">
								<div class="title">
									{{item.title}}
								</div>
								<div class="text">
									{{item.text}}
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- 移动端下展示 end-->
				<div class="card_btm share_center_Up_down animate__animated animate__fadeInUp">
					<div >丰富的营销功能及多维度多标签的可视化数据</div>
					<div class="text">助力商户建立专属SCRM生态客户，实现智能化运营</div>
				</div>
			</div>
		</div>
		<!-- 可视化数据 -->
		<div class="data_pic share_center" ref='data_pic'>
			<div class="pic ">
				<img v-show="dataPicShow" class="animate__animated animate__fadeInUp" src="../../../public/images/bj0.png" >
			</div>
		</div>
		<!-- 私域池养鱼外包服务 -->
		<div class="outsource share_center_Up_down">
			<div ref="outsource" class="wrap animate__animated animate__fadeInUp">
				<div v-show="outsourceTitleShow" class="title share_center_Up_down animate__animated animate__fadeInUp">
					私域池养鱼理论
					<span>门店私域运营服务，私域的循环自动化</span>
				</div>
				<div ref="outsourceList">
					<div v-show="outsourceListShow" class="list share_list_center animate__animated animate__fadeInUp">
						<!-- 1 -->
						<div class="box box1 ">
							<ul>
								<li>需求确认</li>
								<li>营销方案</li>
								<li>内容设计</li>
								<li>CMS在线化</li>
								<li>运营激励</li>
								<li>玩法设计</li>
							</ul>
						</div>
						<div class="arrow"></div>
						<!-- 2 -->
						<div class="box box2">
							<ul>
								<li>多渠道公域发布</li>
								<li class="li2">
									自由私域
									<span>(个微，公众号，社群等)</span>
								</li>
								<!-- <li></li> -->
								<li>新种子社群建立</li>
								<li>智能化工具投放</li>
								<li>H5/海报等裂变</li>
							</ul>
						</div>
						<div class="arrow2"></div>
						<!-- 3 -->
						<div class="box box3 ">
							<ul>
								<li>触达用户： 购买/关注/分享</li>
								<li>企微锁客用户沉淀SCRM</li>
								<li>数据检索</li>
								<li>微信电话等全渠道跟进</li>
								<li>电话/PUSH二次转化</li>
								<li>短信/PUSH用户激活唤醒</li>
							</ul>
						</div>
						<div class="arrow"></div>
						<!-- 4 -->
						<div class="box box4 ">
							<ul>
								<li>商户CDP</li>
								<li>经营决策</li>
								<li>用户激活唤醒</li>
								<li>用户行为管理</li>
								<li>行为数据分析</li>
								<li>DA资产沉淀</li>
							</ul>
						</div>
					</div>
				</div>
				  
			</div>
		</div>
		<!-- 门店私域运营服务流程 -->
		<div class="flow share_center">
			<div ref="flow" class="wrap share_Up_down">
				<div v-show="flowShow" class="title share_center_Up_down animate__animated animate__fadeInUp">
					门店私域运营服务流程
					<span>私域池养鱼外包服务，私域的循环自动化 </span>
				</div>
				<div ref="flowTitList" >
					<div v-show="flowTitListShow" class="tit_list share_list_center animate__animated animate__fadeInUp">
						<div class="box share_center">
							<div class="top">引流阶段</div>
							<span>MarTech裂变系统</span>
						</div>
						<div class="box share_center">
							<div class="top">转化阶段</div>
							<span>SCRM工具+到店服务</span>
						</div>
						<div class="box share_center">
							<div class="top">复消阶段</div>
							<span>SCRM工具+到店服务</span>
						</div>
					</div>
				</div>
				<div ref='flowProcess' > 
					<div v-show="flowProcessShow" class="process animate__animated animate__fadeInUp"></div>
				</div>
				<ul ref="flowList" class="list share_list_center">
					<li v-show="flowListShow" class="share_Up_down-center animate__animated animate__fadeInUp">
						<span>私域</span> 
						<span>建立</span>
					</li>
					<li v-show="flowListShow" class="share_Up_down-center animate__animated animate__fadeInUp">
						<span>私域</span>
						<span>裂变</span>
					</li>
					<li v-show="flowListShow" class="share_Up_down-center animate__animated animate__fadeInUp"> 
						<span>线上</span>
						<span>运营</span>
					</li>
					<li v-show="flowListShow" class="share_Up_down-center animate__animated animate__fadeInUp"> 
						<span>线下</span>
						<span>服务</span>
					</li>
					<li v-show="flowListShow" class="share_Up_down-center animate__animated animate__fadeInUp"> 
						<span>线上</span>
						<span>运营</span>
					</li>
					<li v-show="flowListShow" class="share_Up_down-center animate__animated animate__fadeInUp"> 
						<span>线上</span>
						<span>运营</span>
					</li>
					<li v-show="flowListShow" class="share_Up_down-center animate__animated animate__fadeInUp"> 
						<span>线下</span>
						<span>服务</span>
					</li>
				</ul>
			</div>
		</div>
		<!-- 门店经营痛点 -->
		<div ref='pain_point' class="pain_point share_Up_down">
			<div v-show="painShow" class="title share_center_Up_down animate__animated animate__fadeInUp">
				门店经营痛点
				<span>线下实体店六大经营痛点，如何克服</span>
			</div>
			<div ref="painBigBox" >
				<div v-show="painBigBoxShow" class="big_box animate__animated animate__fadeInUp"></div>
			</div>
			<div ref="painTitle" >
				<div v-show="painTitleShow" class="title share_center_Up_down animate__animated animate__fadeInUp" style="margin-top: 0.56rem;">
					门店刚需和未来趋势
					<span>线下门店的诉求和解决方案</span>
				</div>
			</div>
			
		</div>
		<!-- 趋势 -->
		<div class="trend share_Up_down" ref='trend'>
			<div v-show="trendShow" class="trend_top animate__animated animate__fadeInUp"></div>
			<ul class="list share_list" ref="trendlist" >
				<li v-show="trendListShow" class="share_Up_down animate__animated animate__fadeInUp" v-for="(item,index) in trendList" :key='index'>
					<img :src="item.pic" >
					<span :style="index==1?'color: #385B7D;':index==2?'color: #E76E1D;':index==3?'color: #DD0010;':''">{{item.tit}}</span>
				</li>
			</ul>
			<div ref="trendBtm"  v-show="trendShow" class="btm share_list_center">
				<div v-show="trendBtmShow" class="arrows animate__animated animate__fadeInUp">
					<span>品牌化</span>
				</div>
				<div v-show="trendBtmShow" class="arrows animate__animated animate__fadeInUp">
					<span>线上化</span>
				</div>
				<div v-show="trendBtmShow" class="arrows animate__animated animate__fadeInUp">
					<span>私域化</span>
				</div>
				<div v-show="trendBtmShow" class="arrows animate__animated animate__fadeInUp">
					<span>自运营</span>
				</div>
				<div v-show="trendBtmShow" class="arrows animate__animated animate__fadeInUp">
					<span>智能化</span>
				</div>
			</div>
		</div>
		<brand-box></brand-box>
		
		<!-- <brand-box></brand-box> -->
		<my-footer></my-footer>
	</div>
</template>

<script>
import brandBox from '@/components/brandBox/index.vue'
import myFooter from '@/components/myFooter/index.vue'
export default {
	components:{
		myFooter,
		brandBox
	},
	data() {
		return{
			trendList:[{
				tit:'引流',
				pic:require('../../../public/images/drainage.png')
			},{
				tit:'锁客',
				pic:require('../../../public/images/Lockguest.png')
			},{
				tit:'转化',
				pic:require('../../../public/images/conversion.png')
			},{
				tit:'复购',
				pic:require('../../../public/images/Repurchase.png')
			}],
			caseList:[{
				pic:require('../../../public/images/liuliulife.jpg'),
				title:'溜溜嗨生活',
				text:'生活服务行业（同业/异业）微信 私域流量营销运营工具'
			},{
				pic:require('../../../public/images/liuliucart.jpg'),
				title:'溜溜车友汇',
				text:'垂直于汽服行业同业联盟的微信 私域流量营销运营系统'
			},{
				pic:require('../../../public/images/didi.jpg'),
				title:'嘀嘀来客',
				text:'门店私域流量运营管家'
			}],																					//案例展示
			dataPicShow:false,
			outsourceTitleShow:false,
			flowShow:false,
			painShow:false,
			trendShow:false,
			trendListShow:false,
			trendBtmShow:false,
			painBigBoxShow:false,
			painTitleShow:false,
			flowTitListShow:false,
			flowProcessShow:false,
			flowListShow:false,
			outsourceListShow:false,
			programmeShow:false,
			programmeWrapShow:false,
			processPicShow:false,
			brandShow:false,
			matrixShow:false,
		}
	},
	mounted() {
		window.addEventListener("scroll", this.handleScroll);
		window.addEventListener("scroll", this.handle);
	},
	methods:{
		handleScroll () { // 实现当滚动到指定位置，触发动画
			// let scrollTop =  window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop // 获取窗口滚动条高度
			// this.gdjz('earth', 'earth animated bounceInDown', 50)
			let _this = this
			let refArray = [
				{ref: 'process', show: 'processShow'},
				{ref: 'data_pic', show: 'dataPicShow'},
				{ref: 'brandPos', show: 'brandShow'},
				{ref: 'BrandMatrix', show: 'matrixShow'},
				{ref: 'outsource', show: 'outsourceTitleShow'},
				{ref: 'outsourceList', show: 'outsourceListShow'},
				{ref: 'flow', show: 'flowShow'},
				{ref: 'flowTitList', show: 'flowTitListShow'},
				{ref: 'flowProcess', show: 'flowProcessShow'},
				{ref: 'flowList', show: 'flowListShow'},
				{ref: 'pain_point', show: 'painShow'},
				{ref: 'painBigBox', show: 'painBigBoxShow'},
				{ref: 'painTitle', show: 'painTitleShow'},
				{ref: 'trend', show: 'trendShow'},
				{ref: 'trendlist', show: 'trendListShow'},
				{ref: 'trendBtm', show: 'trendBtmShow'},
				{ref: 'programme', show: 'programmeShow'},
				{ref: 'programmeWrap', show: 'programmeWrapShow'},
		      ]
			  // console.log(refArray)
			refArray.forEach((r,i) => {
				_this.gdjz(r.ref, 20, () => {
					_this[r.show] = true
				})
			})
		},
		gdjz(div, offset, callback) {
			let dom = this.$refs[div] // 等同于document.querySelector('.earth') true
			// console.log(dom)
			if(dom){
				var a,b,c,d;
				d = dom.offsetTop // 元素距离相对父级的高度，这里父级指的是body
				a = eval(d + offset)
				b = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop //  获取窗口滚动条高度
				c = document.documentElement.clientHeight || document.body.clientHeight // 获取浏览器可视区的高度
				if( b + c > a ) {
					callback && callback()
				}
			}
		},
		handle () { // 实现当滚动到指定位置，触发动画
			// let scrollTop =  window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop // 获取窗口滚动条高度
			// this.gdjz('earth', 'earth animated bounceInDown', 50)
			let _this = this
			let refArray = [
				{ref: 'data_pic', show: 'dataPicShow'},
				{ref: 'brandPos', show: 'brandShow'},
				{ref: 'BrandMatrix', show: 'matrixShow'},
				{ref: 'outsource', show: 'outsourceTitleShow'},
				{ref: 'outsourceList', show: 'outsourceListShow'},
				{ref: 'flow', show: 'flowShow'},
				{ref: 'flowTitList', show: 'flowTitListShow'},
				{ref: 'flowProcess', show: 'flowProcessShow'},
				{ref: 'flowList', show: 'flowListShow'},
				{ref: 'pain_point', show: 'painShow'},
				{ref: 'painBigBox', show: 'painBigBoxShow'},
				{ref: 'painTitle', show: 'painTitleShow'},
				{ref: 'trend', show: 'trendShow'},
				{ref: 'trendlist', show: 'trendListShow'},
				{ref: 'trendBtm', show: 'trendBtmShow'},
				{ref: 'programme', show: 'programmeShow'},
				{ref: 'programmeWrap', show: 'programmeWrapShow'},
		      ]
			  // console.log(refArray)
			refArray.forEach((r,i) => {
				_this.gd(r.ref, 20, () => {
					_this[r.show] = false
				})
			})
		},
		gd(div, offset, callback) {
			let dom = this.$refs[div] // 等同于document.querySelector('.earth') true
			// console.log(dom)
			if(dom){
				var a,b,c,d;
				d = dom.offsetTop // 元素距离相对父级的高度，这里父级指的是body
				a = eval(d + offset)
				b = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop //  获取窗口滚动条高度
				c = document.documentElement.clientHeight || document.body.clientHeight // 获取浏览器可视区的高度
				if( b + c < a ) {
					callback && callback()
				}
			}
		},
	}
}
</script>

<style lang="scss" scoped>
	.product{
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		.process{
			width: 100%;
			height: 6rem;
			background-color: #fff;
			
			.title{
				font-size: 0.28rem;
				color: #000000;
				margin-top: 1.18rem;
				margin-bottom: 0.7rem;
				span{
					font-size: 0.18rem;
					color: #999999;
					margin-top: 0.18rem;
				}
			}
			
			.process_pic{
				width: 12rem;
				height: 1.66rem;
				img{
					width: 12rem;
					height: 3.6em;
				}
			}
			.process_pic2{
				display: none;
			}
		}
		.card{
			width: 100%;
			min-height: 4.01rem;
			background-color: #fff;
			
			.card_box{
				width: 12rem;
				z-index: 1;
				
				ul{
					width: 12rem;
					li:nth-child(2){
						margin-top: -0.64rem;
					}
					li:nth-child(2){
						.pic{
							background: url(../../../public/images/product1-1.png)no-repeat center center;
							background-size: 1.1rem 1.03rem;
						}
					}
					li:nth-child(3){
						.pic{
							background: url(../../../public/images/product1-3.png)no-repeat center center;
							background-size: 1.1rem 1.03rem;
						}
					}
					li{
						width: 2.7rem;
						height: 2.06rem;
						background: #FFFFFF;
						box-shadow: 0rem 0rem 0.24rem 0rem rgba(51, 51, 51, 0.05);
						border-radius: 0.2rem;
						margin-top: -0.23rem;
						
						.pic{
							width: 1.1rem;
							height: 1.03rem;
							background: url(../../../public/images/product1-2.png)no-repeat center center;
							background-size: 1.1rem 1.03rem;
							margin-top: 0.34rem;
							margin-bottom: 0.31rem;
						}
						.text{
							font-size: 0.18rem;
						}
					}
				}
				.cooperation{display: none;}
				.cooperationPc{
					width: 11rem;
					height: 8rem;
					.brand{
						font-size: 0.28rem;
						color: #000000;
						margin-top: 1.18rem;
						margin-bottom: 0.7rem;
						span{
							font-size: 0.18rem;
							color: #999999;
							margin-top: 0.18rem;
						}
					}
					.list{
						height: 3.8rem;
						display: flex;
						justify-content: space-between;
						.son{
							width: 3.1rem;
							height: 4.2rem;
							background: #FFFFFF;
							box-shadow: 0px 0px 24px 0px rgba(51, 51, 51, 0.05);
							border-radius: 20px;
							font-size: 0.18rem;
							.pic{
								img{
									width: 100%;
									border-top-left-radius: 20px;
									border-top-right-radius: 20px;
								}
							}
							.content{
								width: 100%;
								padding: 0 24px;
								box-sizing: border-box;
								overflow: hidden;
								.title{
									font-size: 0.26rem;
									color: #000;
									margin-top: 34px;
									font-weight: bold;
									
								}
								.text{
									color: #666;
									margin-top: 14px;
									width: 2.6rem;
									line-height: 24px;
									
								}
							}
						}
					}
				}
				.card_btm{
					font-size: 0.28rem;
					height: 0.63rem;
					color: #000000;
					margin-bottom: 0.42rem;
					
					.text{
						font-size: 0.18rem;
						color: #999999;
					}
				}
			}
		}
		.data_pic{
			width: 100%;
			height: 8rem;
			
			.pic{
				width: 12rem;
				height: 6.78rem;
				
				img{
					width: 12rem;
					height: 6.78rem;
				}
			}
		}
		.outsource{
			width: 100%;
			height: 9.42rem;
			background:#fff url(../../../public/images/bj2.png)no-repeat center 1.32rem;
			background-size:16.34rem 7.89rem ;
			
			.wrap{
				width: 12rem;
				height: 7.88rem;
				background: url(../../../public/images/bj3.png) no-repeat center center;
				background-size: 11.16rem 7.88rem;
				margin-top: 0.35rem;
				
				.title{
					font-size: 0.28rem;
					height: 0.68rem;
					margin-top: 0.75rem;
					span{
						font-size: 0.18rem;
						color: #999999
					}
				}
				.list{
					width: 12rem;
					height: 2.8rem;
					margin-top: 0.75rem;
					
					.box{
						height: 2.8rem;
						border-radius: 0.2rem;
						
						ul{
							width: 100%;
							height: 100%;
							display: flex;
							flex-direction: column;
							justify-content: center;
							margin-left: 0.34rem;
							li{
								font-size: 0.18rem;
								color: #FFFFFF;
								margin-bottom: 0.23rem;
							}
							.li2{
								display: flex;
								flex-direction: column;
								margin-bottom: 0.43rem;
								span{
									font-size: 0.16rem;
									margin-top: 0.1rem;
								}
							}
							li:last-child{
								margin-bottom: 0rem;
							}
						}
					}
					.arrow{
						width: 0.35rem;
						height: 0.25rem;
						background: url(../../../public/images/arrow.png)no-repeat center center;
						background-size: 0.35rem 0.25rem;
					}
					.arrow2{
						width: 0.35rem;
						height: 0.25rem;
						background: url(../../../public/images/arrow2.png)no-repeat center center;
						background-size: 0.35rem 0.25rem;
					}
					.box1{
						width: 1.8rem;
						background: linear-gradient(181deg, #FE9315, #FEA315);
						box-shadow: 0rem 0.06rem 0.08rem 0rem rgba(0, 0, 0, 0.04);
					}
					
					.box2{
						width: 2.2rem;
						background: linear-gradient(180deg, #88CEFF, #4A9CFF);
					}
					.box3{
						width: 2.6rem;
						background: linear-gradient(181deg, #FE9315, #FEA315);
						box-shadow: 0rem 0.06rem 0.08rem 0rem rgba(0, 0, 0, 0.04);
					}
					.box4{
						width: 1.8rem;
						background: linear-gradient(180deg, #88CEFF, #4A9CFF);
					}
				}
			}
		}
		.flow{
			width: 100%;
			height: 8rem;
			background: url(../../../public/images/bj4.png) no-repeat center center;
			background-size: 100% 8rem;
			
			.wrap{
				width: 12rem;
				height: 8rem;
				
				.title{
					font-size: 0.28rem;
					height: 0.68rem;
					margin-top: 0.82rem;
					span{
						font-size: 0.18rem;
						color: #999999
					}
				}
				.tit_list{
					width: 11.76rem;
					height: 1.91rem;
					margin-top: 0.5rem;
					// background-color: red;
					
					.box{
						width: 3.42rem;
						height: 1.91rem;
						
						.top{
							width: 1.8rem;
							height: 0.54rem;
							background: linear-gradient(90deg, #FE5F36 0%, #F9751C 100%);
							border-radius: 0.1rem;
							font-size: 24px;
							color: #FFFFFF;
							text-align: center;
							line-height: 0.54rem;
							margin-bottom: 0.27rem;
						}
						span{
							font-size: 0.24rem;
							color: #000000;
						}
					}
				}
				.process{
					width: 11.97rem;
					height: 1.88rem;
					background: url(../../../public/images/bj5.png)no-repeat center center;
					background-size:11.97rem 1.88rem;
				}
				.list{
					width: 11rem;
					margin-top: 0.23rem;
					li{
						width: 0.78rem;
						height: 0.88rem;
						background-color: #0000FF;
						background:url(../../../public/images/circular.png)no-repeat center center ;
						background-size:0.78rem 0.88rem;
						font-size: 0.18rem;
						color: #000000;
						span{
							margin-top: 0.05rem;
						}
					}
					li:nth-child(2){
						background:url(../../../public/images/circular2.png)no-repeat center center ;
						background-size:0.78rem 0.88rem;
					}
					li:nth-child(3){
						background:url(../../../public/images/circular3.png)no-repeat center center ;
						background-size:0.78rem 0.88rem;
					}
					li:nth-child(4){
						background:url(../../../public/images/circular4.png)no-repeat center center ;
						background-size:0.78rem 0.88rem;
					}
					li:nth-child(5){
						background:url(../../../public/images/circular5.png)no-repeat center center ;
						background-size:0.78rem 0.88rem;
					}
					li:nth-child(6){
						background:url(../../../public/images/circular6.png)no-repeat center center ;
						background-size:0.78rem 0.88rem;
					}
					li:nth-child(7){
						background:url(../../../public/images/circular7.png)no-repeat center center ;
						background-size:0.78rem 0.88rem;
					}
				}
			}
		}
		.pain_point{
			width: 100%;
			height: 9rem;
			background:url(../../../public/images/bj6.png)no-repeat center 0.55rem;
			background-size: 13.77rem 5.91rem;
			.title{
				font-size: 0.28rem;
				height: 0.68rem;
				margin-top: 0.99rem;
				span{
					font-size: 0.18rem;
					color: #999999
				}
			}
			.big_box{
				width: 9.35rem;
				height: 5.71rem;
				background-color: #0000FE;
				background: url(../../../public/images/bj11.png)no-repeat center center;
				background-size: 12rem 8.05rem;
				// margin-top: 1.53rem;
			}
		}
		.trend{
			width: 100%;
			height: 8.21rem;
			background: url(../../../public/images/bj7.png)no-repeat center center;
			background-size: 100% 8.21rem;
			
			.trend_top{
				width: 8.67rem;
				height: 2.65rem;
				margin-top: 0.61rem;
				background: url(../../../public/images/bj8.png)no-repeat center center;
				background-size: 8.67rem 2.65rem;
			}
			.list{
				width: 9.74rem;
				margin-top: 0.26rem;
				li{
					width: 1.07rem;
					img{
						width: 1.07rem;
						height: 1.07rem;
					}
					span{
						margin-top: 0.24rem;
						font-size: 0.24rem;
						color: #1966E2;
					}
				}
			}
			.btm{
				width: 10.31rem;
				height: 1.12rem;
				margin-top: 1.03rem;
				.arrows{
					width: 2.04rem;
					height: 1.12rem;
					background: url(../../../public/images/bjArrow.png)no-repeat center top;
					background-size: 2.04rem 1.12rem;
					display: flex;
					span{
						font-size: 0.22rem;
						color: #FFFFFF;
						margin-left: 0.87rem;
						line-height: 0.75rem;
					}
				}
				.arrows:nth-child(2){
					background: url(../../../public/images/bjArrow1.png)no-repeat center top;
					background-size: 2.04rem 1.12rem;
				}
				.arrows:nth-child(3){
					background: url(../../../public/images/bjArrow2.png)no-repeat center top;
					background-size: 2.04rem 1.12rem;
				}
				.arrows:nth-child(4){
					background: url(../../../public/images/bjArrow3.png)no-repeat center top;
					background-size: 2.04rem 1.12rem;
				}
				.arrows:nth-child(5){
					background: url(../../../public/images/bjArrow4.png)no-repeat center top;
					background-size: 2.04rem 1.12rem;
				}
			}
		}
		.programme{
			width: 100%;
			height: 6rem;
			background-color: #fff;
			.title{
				font-size: 0.28rem;
				height: 0.68rem;
				margin-top: 0.87rem;
				span{
					font-size: 0.18rem;
					color: #999999
				}
			}
			.wrap{
				width: 10.31rem;
				height: 3.03rem;
				margin-top: 0.76rem;
				
				.left{
					width: 3.6rem;
					height: 3.03rem;
					background: url(../../../public/images/bj12.png) no-repeat center center;
					background-size: 3.6rem 3.03rem;
				}
				.right{
					ul{
						li{
							font-size: 0.22rem;
							color: #000000;
							display: flex;
							// margin-top: 0.21rem;
							line-height: 0.32rem;
							
							p{
								margin-top: 0.05rem;
								width: 0.09rem;
								height: 0.24rem;
								background: #5394FF;
								margin-right: 0.34rem;
							}
							span{
								width: 4.94rem;
							}
						}
						li:nth-child(2){
							margin-top: 0.57rem;
							p{
								width: 0.09rem;
								height: 0.24rem;
								background: #FF7818;
								margin-right: 0.34rem;
							}
						}
						li:nth-child(3){
							margin-top: 0.5rem;
							p{
								width: 0.09rem;
								height: 0.24rem;
								background: #FF1A36;
								margin-right: 0.34rem;
							}
						}
					}
				}
			}
		}
	}
	
	// 移动端样式
	@media (max-width:1206px){
		.product{
			width: 100%;
			display: flex;
			flex-direction: column;
			align-items: center;
			.process{
				width: 100%;
				height: 6rem;
				background-color: #fff;
				.title{
					font-size: 0.32rem;
					color: #000000;
					margin-top: 0.6rem;
					margin-bottom: 0.7rem;
					span{
						font-size: 0.24rem;
						color: #999999;
						margin-top: 0.18rem;
					}
				}
				.process_pic{
					width: 12rem;
					height: 1.66rem;
					display: none;
					img{
						width: 12rem;
						height: 1.66rem;
					}
				}
				.process_pic2{
					width: 7.16rem;
					height: 3.5rem;
					display: block;
					img{
						width: 7.16rem;
						height: 3.5rem;
					}
				}
			}
			.card{
				width: 100%;
				min-height: 3.2rem;
				background-color: #fff;
				
				
				.card_box{
					width: 100%;
					min-height: 3.2rem;
					
					ul{
						width: 100%;
						
						display: flex;
						justify-content: space-around;
						li:nth-child(2){
							margin-top: -0.3rem;
						}
						li:nth-child(2){
							.pic{
								background: url(../../../public/images/product1-1.png)no-repeat center center;
								background-size: 0.72rem 0.67rem;
							}
						}
						li:nth-child(3){
							.pic{
								background: url(../../../public/images/product1-3.png)no-repeat center center;
								background-size: 0.72rem 0.67rem;
							}
						}
						li{
							width: 2.3rem;
							height:1.6rem;
							background: #FFFFFF;
							box-shadow: 0rem 0rem 0.24rem 0rem rgba(51, 51, 51, 0.05);
							border-radius: 0.2rem;
							margin-top: -0.1rem;
							
							.pic{
								width: 0.72rem;
								height: 0.67rem;
								background: url(../../../public/images/product1-2.png)no-repeat center center;
								background-size: 0.72rem 0.67rem;
								margin-top: 0.34rem;
								margin-bottom: 0.15rem;
							}
							.text{
								font-size: 0.18rem;
							}
						}
					}
					.cooperationPc{
						display: none;
					}
					.cooperation{
						display: block;
						width: 100%;
						display: flex;
						flex-direction: column;
						align-items: center;
						.brand{
							font-size: 0.28rem;
							color: #000000;
							margin-top: 1.18rem;
							margin-bottom: 0.7rem;
							span{
								font-size: 0.18rem;
								color: #999999;
								margin-top: 0.18rem;
							}
						}
						.card_btm{
							font-size: 0.32rem;
							color: #000000;
							margin-bottom: 0.56rem;
							
							.text{
								font-size: 0.24rem;
								color: #999999;
							}
						}
						.list{
							width: 6.9rem;
							min-height: 1.9rem;
							
							.son{
								width: 6.9rem;
								height: 1.9rem;
								background: #FFFFFF;
								box-shadow: 0px 0px 0.24rem 0px rgba(51, 51, 51, 0.05);
								border-radius: 0.2rem;
								display: flex;
								margin-bottom: 0.33rem;
								
								.pic{
									width: 3.09rem;
									height: 1.9rem;
									border-top-left-radius: 0.2rem;
									border-bottom-left-radius: 0.2rem;
									img{
										width: 3.09rem;
										height: 1.9rem;
										border-top-left-radius: 0.2rem;
										border-bottom-left-radius: 0.2rem;
									}
								}
								.content{
									width: 3.81rem;
									height: 1.9rem;
									border-top-right-radius: 0.2rem;
									border-bottom-right-radius: 0.2rem;
									.title{
										margin-top: 0.37rem;
										font-size: 0.32rem;
										color: #000000;
										margin-left: 0.31rem;
										margin-bottom: 0.23rem;
									}
									.text{
										width: 3.2rem;
										font-size: 0.24rem;
										margin-left: 0.31rem;
										color: #666666;
										line-height: 0.32rem;
									}
								}
							}
						}
					}
					.card_btm{
						margin-top: 0.4rem;
						font-size: 0.32rem;
						color: #000000;
						margin-bottom: 0.49rem;
						
						.text{
							font-size: 0.24rem;
							color: #999999;
						}
					}
				}
				
			}
			.data_pic{
				width: 100%;
				height: 4.5rem;
				
				.pic{
					width: 6.92rem;
					height: 3.88rem;
					
					img{
						width: 6.92rem;
						height: 3.88rem;
					}
				}
			}
			.outsource{
				width: 100%;
				height: 6.88rem;
				
				.wrap{
					width: 100%;
					height: 6.5rem;
					background: url(../../../public/images/phoneBj-2.png) no-repeat center 1.81rem;
					background-size: 7.5rem 5.07rem;
					margin-top: 0.35rem;
					
					.title{
						font-size: 0.32rem;
						height: 0.68rem;
						margin-top: 0.49rem;
						span{
							font-size: 0.24rem;
							color: #999999
						}
					}
				
					.list{
						width: 100%;
						height: 1.62rem;
						margin-top: 0.75rem;
						display: none;
					}
				}
			}
			.flow{
				width: 100%;
				height: 5.41rem;
				
				.wrap{
					width:100%;
					height: 5.41rem;
					background:#fff url(../../../public/images/phonebj3.png) no-repeat center 1.8rem;
					background-size: 7.5rem 3.61rem;
					
					.title{
						font-size: 0.32rem;
						height: 0.68rem;
						margin-top: 0.82rem;
						span{
							font-size: 0.24rem;
							color: #999999;
							margin-top: 0.19rem;
							
						}
					}
					.tit_list{
						width: 6.9rem;
						height: 1.91rem;
						margin-top: 0.5rem;
						display: none;
				
					}
					.process{
						width: 6.9rem;
						height: 1.08rem;
						background: url(../../../public/images/bj5.png)no-repeat center center;
						background-size:6.9rem 1.08rem;
						display: none;
					}
					.list{
						width: 6.31rem;
						margin-top: 0.23rem;
						display: none;
					}
				}
			}
			.pain_point{
				width: 100%;
				height: 8rem;
				background:#fff url(../../../public/images/phonebj4.png)no-repeat center 0.72rem;
				background-size: 7.5rem 5.97rem;
				.title{
					font-size: 0.32rem;
					height: 0.68rem;
					margin-top: 0rem;
					span{
						font-size: 0.24rem;
						color: #999999
					}
				}
				.big_box{
					width: 100%;
					height: 5.97rem;
					margin-top: 0;
					
				}
			}
			.trend{
				width: 100%;
				height: 4.98rem;
				background:#fff url(../../../public/images/phonebj5.png)no-repeat center center;
				background-size: 7.5rem 4.98rem;
				
				.trend_top{
					width: 8.67rem;
					height: 2.65rem;
					margin-top: 0.61rem;
					background: url(../../../public/images/bj8.png)no-repeat center center;
					background-size: 8.67rem 2.65rem;
					display: none;
				}
				.list{
					width: 9.74rem;
					margin-top: 0.26rem;
					display: none;
				}
				.btm{
					width: 10.31rem;
					height: 1.12rem;
					margin-top: 1.03rem;
					display: none;
				}
			}
			.programme{
				width: 100%;
				height: 5.5rem;
				background-color: #fff;
				// margin-bottom: 0.88rem;
				
				.title{
					font-size: 0.32rem;
					height: 0.68rem;
					margin-top: 0.72rem;
					span{
						font-size: 0.24rem;
						color: #999999
					}
				}
				.wrap{
					width: 7.5rem;
					height: 2.73rem;
					margin-top: 0.76rem;
					display: flex;
					justify-content: flex-start;
					background: url(../../../public/images/phonebj6.png) no-repeat center center;
					background-size: 6.71rem 2.73rem;
					
					.left{
						width: 3.25rem;
						height: 2.73rem;
						background: #0000FE;
						margin-left: 0.3rem;
						display: none;
					}
					.right{
						width: 2.92rem;
						margin-left: 0.34rem;
						display: none;
						ul{
							width: 2.92rem;
							li{
								width: 2.92rem;
								font-size: 0.14rem;
								color: #000000;
								display: flex;
								// margin-top: 0.21rem;
								line-height: 0.28rem;
								
								p{
									margin-top: 0.05rem;
									width: 0.09rem;
									height: 0.24rem;
									background: #5394FF;
									margin-right: 0.26rem;
								}
								span{
									width: 100%;
								}
							}
							li:nth-child(2){
								margin-top: 0.32rem;
								p{
									width: 0.09rem;
									height: 0.24rem;
									background: #FF7818;
									margin-right: 0.34rem;
								}
							}
							li:nth-child(3){
								margin-top: 0.35rem;
								p{
									width: 0.09rem;
									height: 0.24rem;
									background: #FF1A36;
									margin-right: 0.34rem;
								}
							}
						}
					}
				}
			}
			// .programme{
			// 	width: 100%;
			// 	height: 6.74rem;
			// 	background-color: #fff;
			// 	.title{
			// 		font-size: 0.32rem;
			// 		height: 0.68rem;
			// 		margin-top: 0.87rem;
			// 		span{
			// 			font-size: 0.24rem;
			// 			color: #999999
			// 		}
			// 	}
			// 	.wrap{
			// 		width: 7.5rem;
			// 		height: 3.03rem;
			// 		margin-top: 0.76rem;
			// 		display: flex;
			// 		justify-content: flex-start;
					
			// 		.left{
			// 			width: 3.25rem;
			// 			height: 2.73rem;
			// 			background: #0000FE;
			// 			margin-left: 0.3rem;
			// 		}
			// 		.right{
			// 			width: 2.92rem;
			// 			margin-left: 0.34rem;
			// 			ul{
			// 				width: 2.92rem;
			// 				li{
			// 					width: 2.92rem;
			// 					font-size: 0.20rem;
			// 					color: #000000;
			// 					display: flex;
			// 					// margin-top: 0.21rem;
			// 					line-height: 0.32rem;
								
			// 					p{
			// 						margin-top: 0.05rem;
			// 						width: 0.09rem;
			// 						height: 0.24rem;
			// 						background: #5394FF;
			// 						margin-right: 0.26rem;
			// 					}
			// 					span{
			// 						width: 100%;
			// 					}
			// 				}
			// 				li:nth-child(2){
			// 					margin-top: 0.57rem;
			// 					p{
			// 						width: 0.09rem;
			// 						height: 0.24rem;
			// 						background: #FF7818;
			// 						margin-right: 0.34rem;
			// 					}
			// 				}
			// 				li:nth-child(3){
			// 					margin-top: 0.5rem;
			// 					p{
			// 						width: 0.09rem;
			// 						height: 0.24rem;
			// 						background: #FF1A36;
			// 						margin-right: 0.34rem;
			// 					}
			// 				}
			// 			}
			// 		}
			// 	}
			// }
		}
	}
</style>
